import React from 'react';
import { Card } from 'react-bootstrap';
import Container from 'landing-page/components/common/Container';

// Highlight Blog Card Placeholder Component
const HighlightBlogPlaceholder: React.FC = () => {
    return (
        <div className='mb-10' style={{height: '460px'}}>
            <Card className='border-0 shadow-sm rounded-4 overflow-hidden h-100'>
                <div className='position-relative h-100'>
                    {/* Image placeholder */}
                    <div className='bg-light h-100 w-100' style={{ minHeight: '400px' }}>
                        <div className='position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center'>
                            <div className='spinner-border text-primary' role='status'>
                                <span className='visually-hidden'>Loading...</span>
                            </div>
                        </div>
                    </div>
                    
                    {/* Dark overlay */}
                    <div 
                        className='position-absolute top-0 start-0 w-100 h-100' 
                        style={{ 
                            background: 'rgba(0, 0, 0, 0.4)',
                            zIndex: 1
                        }}
                    ></div>
                
                    {/* Content overlay using Card.Body */}
                    <Card.Body className='position-absolute top-0 start-0 w-100 h-100 text-white d-flex flex-column justify-content-between' style={{ zIndex: 2, background: 'transparent' }}>
                        {/* Date tag placeholder at top */}
                        <div className='d-flex flex-column justify-content-center bg-primary text-white p-2 rounded-2' style={{ width: '56px', height: '56px' }}>
                            <div className='placeholder-glow'>
                                <div className='placeholder bg-white bg-opacity-75 rounded' style={{ height: '20px', width: '40px' }}></div>
                                <div className='placeholder bg-white bg-opacity-75 rounded mt-1' style={{ height: '15px', width: '30px' }}></div>
                            </div>
                        </div>
                        
                        {/* Content placeholder at bottom */}
                        <div>
                            <div className='d-flex align-items-center gap-2 mb-2'>
                                <i className='bi bi-tag text-primary'></i>
                                <div className='placeholder-glow'>
                                    <div className='placeholder bg-white bg-opacity-75 rounded' style={{ height: '12px', width: '80px' }}></div>
                                </div>
                            </div>
                            <div className='placeholder-glow'>
                                <div className='placeholder bg-white bg-opacity-75 rounded mb-2' style={{ height: '24px', width: '100%' }}></div>
                                <div className='placeholder bg-white bg-opacity-75 rounded' style={{ height: '24px', width: '70%' }}></div>
                            </div>
                        </div>
                    </Card.Body>
                </div>
            </Card>
        </div>
    );
};

// Blog List Card Placeholder Component
const BlogListCardPlaceholder: React.FC = () => {
    return (
        <Card className='border-0 shadow-sm rounded-4 overflow-hidden h-100'>
            <div className='row g-0' style={{height: '280px'}}>
                <div className='col-5'>
                    <div className='position-relative h-100'>
                        {/* Image placeholder */}
                        <div className='bg-light h-100 w-100'>
                            <div className='placeholder-glow h-100 d-flex align-items-center justify-content-center'>
                                <div className='spinner-border text-primary' role='status'>
                                    <span className='visually-hidden'>Loading...</span>
                                </div>
                            </div>
                        </div>
                        
                        {/* Dark overlay */}
                        <div 
                            className='position-absolute top-0 start-0 w-100 h-100' 
                            style={{ 
                                background: 'rgba(0, 0, 0, 0.2)',
                                zIndex: 1
                            }}
                        ></div>
                        
                        {/* Date tag placeholder */}
                        <div className='position-absolute top-0 start-0 m-2' style={{ zIndex: 2 }}>
                            <div className='bg-primary text-white p-2 rounded-2 small fw-bold' style={{ width: '42px', height: '42px' }}>
                                <div className='placeholder-glow'>
                                    <div className='placeholder bg-white bg-opacity-75 rounded' style={{ height: '16px', width: '100%' }}></div>
                                    <div className='placeholder bg-white bg-opacity-75 rounded mt-1' style={{ height: '12px', width: '100%' }}></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='col-7'>
                    <Card.Body className='d-flex flex-column w-100' style={{height: '280px'}}>
                        <div className='d-flex align-items-center gap-2 mb-2'>
                            <i className='bi bi-tag text-primary'></i>
                            <div className='placeholder-glow'>
                                <div className='placeholder bg-secondary rounded' style={{ height: '12px', width: '80px' }}></div>
                            </div>
                        </div>
                        <div className='placeholder-glow mb-2'>
                            <div className='placeholder bg-secondary rounded' style={{ height: '24px', width: '100%' }}></div>
                        </div>
                        <div className='placeholder-glow mb-3'>
                            <div className='placeholder bg-secondary rounded' style={{ height: '16px', width: '100%' }}></div>
                            <div className='placeholder bg-secondary rounded mt-1' style={{ height: '16px', width: '80%' }}></div>
                        </div>
                        <div className='mt-auto'>
                            <div className='placeholder-glow'>
                                <div className='placeholder bg-primary rounded' style={{ height: '20px', width: '120px' }}></div>
                            </div>
                        </div>
                    </Card.Body>
                </div>
            </div>
        </Card>
    );
};

// Search Section Placeholder Component
const SearchSectionPlaceholder: React.FC = () => {
    return (
        <Card className='mb-10 border-0 shadow-none rounded-4 overflow-hidden' style={{backgroundColor: '#FFF6F5'}}>
            <Card.Body>
                <Card.Title as='h4' className='fw-bold' style={{textTransform: 'unset'}}>
                    Cari Disini
                </Card.Title>
                
                {/* Search input placeholder */}
                <div className='placeholder-glow'>
                    <div className='placeholder bg-white rounded' style={{ height: '48px', width: '100%' }}></div>
                </div>
            </Card.Body>
        </Card>
    );
};

// Newest Post Card Placeholder Component
const NewestPostCardPlaceholder: React.FC = () => {
    return (
        <Card className='border-0 shadow-none rounded-4 overflow-hidden h-100 bg-transparent'>
            <div className='row g-0' style={{height: '120px'}}>
                <div className='col-5'>
                    <div className='position-relative h-100'>
                        {/* Image placeholder */}
                        <div className='bg-light h-100 w-100'>
                            <div className='placeholder-glow h-100 d-flex align-items-center justify-content-center'>
                                <div className='spinner-border text-primary' role='status'>
                                    <span className='visually-hidden'>Loading...</span>
                                </div>
                            </div>
                        </div>
                        
                        {/* Dark overlay */}
                        <div 
                            className='position-absolute top-0 start-0 w-100 h-100' 
                            style={{ 
                                background: 'rgba(0, 0, 0, 0.2)',
                                zIndex: 1
                            }}
                        ></div>
                        
                        {/* Date tag placeholder */}
                        <div className='position-absolute top-0 start-0 m-2' style={{ zIndex: 2 }}>
                            <div className='bg-primary text-white p-2 rounded-2 small fw-bold' style={{ width: '42px', height: '42px' }}>
                                <div className='placeholder-glow'>
                                    <div className='placeholder bg-white bg-opacity-75 rounded' style={{ height: '16px', width: '100%' }}></div>
                                    <div className='placeholder bg-white bg-opacity-75 rounded mt-1' style={{ height: '12px', width: '100%' }}></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='col-7'>
                    <Card.Body className='d-flex flex-column w-100 p-5' style={{height: '120px'}}>
                        <div className='d-flex align-items-center gap-2 mb-2'>
                            <i className='bi bi-tag text-primary'></i>
                            <div className='placeholder-glow'>
                                <div className='placeholder bg-secondary rounded' style={{ height: '12px', width: '60px' }}></div>
                            </div>
                        </div>
                        <div className='placeholder-glow mb-2'>
                            <div className='placeholder bg-secondary rounded' style={{ height: '18px', width: '100%' }}></div>
                        </div>
                    </Card.Body>
                </div>
            </div>
        </Card>
    );
};

// Categories Section Placeholder Component
const CategoriesSectionPlaceholder: React.FC = () => {
    return (
        <Card className='mb-10 border-0 shadow-none rounded-4 overflow-hidden' style={{backgroundColor: '#FFF6F5'}}>
            <Card.Body>
                <Card.Title as='h4' className='fw-bold' style={{textTransform: 'unset'}}>Kategori</Card.Title>
                
                <div className='d-flex flex-column gap-4 mt-5'>
                    {[1, 2, 3, 4].map((index) => (
                        <div className='d-flex align-items-center justify-content-between gap-2' key={index}>
                            <div className='placeholder-glow'>
                                <div className='placeholder bg-secondary rounded' style={{ height: '20px', width: `${80 + (index * 20)}px` }}></div>
                            </div>
                            <div className='placeholder-glow'>
                                <div className='placeholder bg-secondary rounded' style={{ height: '20px', width: '30px' }}></div>
                            </div>
                        </div>
                    ))}
                </div>
            </Card.Body>
        </Card>
    );
};

// Main Blog Placeholder Component
const BlogPlaceholder: React.FC = () => {
    return (
        <Container className='py-10'>
            <div className='row d-flex w-100'>
                <div className='col-md-8'>
                    {/* Highlight blog card placeholder */}
                    <HighlightBlogPlaceholder />
                    
                    {/* Blog list cards placeholder */}
                    <div className='row gap-10 d-flex flex-column flex-nowrap align-items-center w-100 m-0'>
                        {[1, 2, 3].map((index) => (
                            <div className='col p-0' key={index}>
                                <BlogListCardPlaceholder />
                            </div>
                        ))}
                    </div>
                </div>
                
                <div className='col-md-4'>
                    {/* Search section placeholder */}
                    <SearchSectionPlaceholder />
                    
                    {/* Newest posts section placeholder */}
                    <Card className='mb-10 border-0 shadow-none rounded-4 overflow-hidden' style={{backgroundColor: '#FFF6F5'}}>
                        <Card.Body>
                            <Card.Title as='h4' className='fw-bold' style={{textTransform: 'unset'}}>Artikel Terbaru</Card.Title>
                            
                            <div className='row gap-5 d-flex flex-column flex-nowrap align-items-center w-100 m-0'>
                                {[1, 2, 3].map((index) => (
                                    <div className='col p-0' key={index}>
                                        <NewestPostCardPlaceholder />
                                    </div>
                                ))}
                            </div>
                        </Card.Body>
                    </Card>
                    
                    {/* Categories section placeholder */}
                    <CategoriesSectionPlaceholder />
                </div>
            </div>
        </Container>
    );
};

export { 
    BlogPlaceholder, 
    HighlightBlogPlaceholder, 
    BlogListCardPlaceholder, 
    SearchSectionPlaceholder, 
    NewestPostCardPlaceholder, 
    CategoriesSectionPlaceholder 
};
